export default __webpack_public_path__ + "static/media/nantes11.cf8d9305.jpg";